import api from '../api';
import { serviceReutils } from '../../utils/reutils';

export const ServiceTipoTecnologia = {
  ...serviceReutils({ name: 'rotas/v1/tipoTecnologia', api }),
};
